import { load } from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

document.addEventListener('DOMContentLoaded', () => {
  load('*');

  const relatedProductsSlider = document.querySelector(
    '.article__related-products--slider'
  );

  if (relatedProductsSlider) {
    this.relatedProductSlider = new Flickity(relatedProductsSlider, {
      freeScroll: false,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      setGallerySize: true,
      cellAlign: 'left',
      watchCSS: true,
      wrapAround: false,
    });
  }

  const ambassadorListingSlider = document.querySelector(
    '.ambassadors__slider'
  );

  if (ambassadorListingSlider) {
    this.ambassadorListingSlider = new Flickity(ambassadorListingSlider, {
      freeScroll: false,
      autoplay: false,
      contain: false,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      setGallerySize: true,
      cellAlign: 'center',
      watchCSS: true,
      wrapAround: true,
    });
  }
});
